import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { CdnImgModule } from "@webapp/shared/directives/cdn-img/cdn-img.module";
import { IndicatorModule } from "@webapp/shared/indicator/indicator.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiModalModule } from "@webapp/ui/modal/modal.module";
import { UiNotificationModule } from "@webapp/ui/notification/notification.module";
import { StatusActionComponent } from "./components/status-action/status-action.component";
import { TeamsApiService } from "./services/teams-api.service";
import { TeamsFacade } from "./services/teams-facade.service";
import { TeamsState } from "./services/teams-state.service";

@NgModule({
  imports: [CommonModule, LocalizationModule, IndicatorModule, UiIconModule, UiButtonModule, UiModalModule, UiNotificationModule, CdnImgModule],
  declarations: [StatusActionComponent],
  providers: [TeamsFacade, TeamsApiService, TeamsState],
})
export class TeamsModule {}
